<template>
  <HelloQrcode v-if="indexShow" :dateweek="dateweek" :network="netStatus"></HelloQrcode>
  <Outgoing v-else-if="kanbanType=='wms-outgoing'" :dateweek="dateweek" :network="netStatus" :payload="refreshData.payload"/>
  <Incoming v-else-if="kanbanType=='wms-incoming'" :dateweek="dateweek" :network="netStatus" :payload="refreshData.payload"/>
  <Quality v-else-if="kanbanType=='mes-quality-control'" :dateweek="dateweek" :network="netStatus" :payload="refreshData.payload" :organizationName="refreshData.organizationName"/>
  <Task v-else-if="kanbanType=='mes-production-task'" :dateweek="dateweek" :network="netStatus" :payload="refreshData.payload" :organizationName="refreshData.organizationName"/>
  <Progress v-else-if="kanbanType=='mes-production-schedule'" :dateweek="dateweek" :network="netStatus" :payload="refreshData.payload" :organizationName="refreshData.organizationName"/>
  <DeviceStatus ref="DeviceStatus" v-else-if="kanbanType=='andon-evt-device'" :organizationId="refreshData.organizationId"/>
  <Event ref="Event" v-else-if="kanbanType=='andon-evt-notice'" :organizationId="refreshData.organizationId"></Event>
</template>
<script>
import { getChinaDateAndWeek } from '../utils/tools'
import HelloQrcode from '../components/HelloQrcode.vue'
import Outgoing from "./warehouse/Outgoing.vue";
import Incoming from "./warehouse/Incoming.vue";
import Task from "./production/Task.vue";
import Progress from "./production/Progress.vue";
import Quality from "./production/Quality.vue";
import DeviceStatus from "./device/DeviceStatus.vue";
import Event from "./device/Event.vue";

import { bigscreenList, fetchToken } from "@/api/bigscreen/bigscreen";
//版本号
const version = '250918'

export default {
  components: {
    HelloQrcode,
    Outgoing,
    Incoming,
    Task,
    Progress,
    Quality,
    DeviceStatus,
    Event
  },
  data: function () {
    return {
      deviceId:null,
      indexShow: true,
      refreshInterval:60*1000,
      timer: undefined,
      fetchTokenInterval: undefined,
      refreshDataInterval: undefined,
      refreshData:{},
      kanbanType:{
        value:-1
      },
      dateweek: {},
      network: true,
      bind:false,
      ServceOnline:true,
      vConsole:null,
    }
  },
  methods: {
    start(){
      this.indexShow=true
      this.deviceId=localStorage.getItem('deviceId')
      this.clearAllInterval();
      this.register()
    },
    registerTimeout(){
      this.clearAllInterval();
      this.fetchTokenInterval=setTimeout(()=>{
        this.register()
      },10000)
    },
    getbigscreenDataTimeout(){
      clearTimeout(this.refreshDataInterval)
      this.refreshDataInterval=setTimeout(() => {
            this.getbigscreenData()
      }, this.refreshInterval);
    },
    register() {
      if(!this.deviceId) {
        this.deviceId=localStorage.getItem('deviceId')
      }
      fetchToken(this.deviceId).then(res => {
          this.ServceOnline=true
          this.bind=true
          localStorage.setItem("X_AccessToken", res.result.accessToken)
          this.getbigscreenData()
        }
      ).catch(err=>{
        if(err.success!=undefined&&err.code==404){
          this.bind=false
          this.ServceOnline=true
        }
        else{
          this.ServceOnline=false
        }
        this.registerTimeout()
      })
    },
    getbigscreenData() {
      // this.kanbanType = 'andon-evt-device'
      bigscreenList({ serialNo: this.deviceId }).then(res => {
          this.ServceOnline=true
          this.refreshInterval = (res.result.kanban.refreshInterval - 0) * 60000
          this.refreshData=res.result
          this.kanbanType=this.refreshData.kanban.code
          // this.kanbanType = 'andon-evt-device' //'andon-evt-notice'
          this.indexShow=false
          this.getbigscreenDataTimeout()
          if(this.kanbanType=='andon-evt-device'){
            this.$refs.DeviceStatus.getList()
            this.$refs.DeviceStatus.updateLastTime()
          }
           if(this.kanbanType=='andon-evt-notice'){
            this.$refs.Event.getList()
          }
        }
      ).catch(err=>{
        if(err.success!=undefined){
          //console.log('getbigscreenData',err)
          this.registerTimeout()
        }
        else{
          this.ServceOnline=false
          this.getbigscreenDataTimeout()
        }
      })
    },
    clearAllInterval() {
      if(this.fetchTokenInterval){
        clearTimeout(this.fetchTokenInterval)
      }
      if(this.refreshDataInterval){
        clearTimeout(this.refreshDataInterval)
      }
      this.refreshData = null;
    },
    getNetworkInfo() {
      if (navigator.onLine) {
        this.network = true;
        localStorage.removeItem("network")
      } else {
        this.network = false;
      }
    }
  },
  computed: {
    netStatus:function (){
      var msg=null
      if(!this.bind){
        msg='未绑定'
      }
      if(this.network&&!this.ServceOnline){
        msg='通讯中断'
      }
      if(!this.network){
        msg='网络不可用'
      }
      return{
        version:version,
        msg:msg,
        deviceId:this.deviceId
      }
    },
    clear: function () {
      return this.$route.query.clear === "1"
    }
  },
  created: function () {
    if (this.clear) {
      localStorage.clear()
      location.replace('/')
    }
    
    if(this.$route.query.dev==='1'){
      this.vConsole = new window.VConsole();
    }
    this.start()
    
  },
  mounted() {
    document.body.style.setProperty(
      "--w",
      Math.min(document.body.clientWidth, document.body.clientHeight * 0.5625) +
      "px"
    );
    // 检测断网
    this.timer = setInterval(() => {
      this.dateweek = getChinaDateAndWeek()
      this.network = navigator.onLine;
    },500);
  },
  // 销毁时清除计时器
  beforeDestroy: function () {
    //console.log('beforeDestroy')
    this.clearAllInterval();
  },
};


</script>

<style lang="less" scoped>
.index-wrapper {
  //--w: ~"min(100vw, 56.25vh)";
  display: grid;
  grid-template-rows: auto 1fr auto;

  width: var(--w);
  height: 90vh;
  margin: 0 auto;
  padding: 9vh calc(50vw - var(--w) / 2) 0;

  background: #2f2f2f;
  color: white;
  font-family: "Alibaba PuHuiTi 2.0 65 Medium", 'Avenir', Helvetica, Arial, sans-serif;
  font-size: calc(var(--w) * 0.07);

  .logo {
    height: 22.5vh;

    img {
      width: 30%;
    }
  }

  .qrcode {
    img {
      width: 80%;
    }
  }

  .device-info {
    font-size: 0.618em;
  }
}
.footer {
  height: 4vh;
  background:  #D0E9FF;
  padding: 5px 40px 5px 20px;
  color: #606266;
  display: flex;
  justify-content: space-between;

  div {
      display: flex;
      align-items: center;
       .icon{
          width: 30px;
          height: auto;
          vertical-align:middle;
          margin: 0 0 0 20px;
      }
  }

}

</style>



// WEBPACK FOOTER //
// src/views/Index.vue